import styled from "styled-components";
import { Layout } from "antd";
import { NavLink } from "react-router-dom";

const { Sider, Header } = Layout;

export const AppLayoutWrapper = styled.div`
    display: flex;
    height: 100% !important;
    
    #page-layout{
        max-height: 100%;
    }
    #page-content {
        height: calc(100% - 68px);
        background: var(--white);
    }
`;

export const SidebarWrapper = styled(Sider)`
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    box-shadow: 0px 1px 4px #858585;
    z-index: 2;
    position: sticky !important;
    .logo {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 40px 10px 40px 0px;

        img {
            width: 140px;
        }
    }
    @media (max-width:1600px){
        .logo{
            margin:25px 7px 25px 0px;
            img{
                width:120px;
            }
        }
    }

    .ant-menu-submenu-title,
    .ant-menu-item {
        height: 46px !important;
        @media (max-width:1600px){
            padding-left:16px !important;
        }
        span {
            color: var(--primary-color);
            font-weight: 400;
            font-size: 14px !important;
            padding: 20px 10px 20px 4px;
        }
    }

    .ant-menu-item-selected {
        background-color: #ecf7ff !important;
        color: var(--primary-color);

        p {
            font-weight: bold;
        }
    }

    .label-icon {
        width: 18px;
    }

    .label-title {
        color: var(--primary-color);
        font-weight: 400;
        margin-left: 8px;
        text-wrap: wrap;
        line-height: 15px;
    }
`;

export const MenuLink = styled(NavLink)`
    text-decoration: none !important;
    &:hover {
        text-decoration: none;
    }

    a {
        text-decoration: none !important;
    }
`;

export const HeaderWrapper = styled.div`
    background: var(--white);
    z-index: 1;
    box-sizing: border-box;
    width: 100%;
    line-height: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;


    .header-title {
        margin: 0 24px;
        font-family: 'DM Sans', sans-serif;
        font-size: 40px;
        font-weight: 700;
        line-height: 40px;
        color: #091B49;
        text-align: left;
    }

    .header-details {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .header-img {
        width: auto;
        max-width: 83px;
        height: auto;
        max-height: 44px;
    }

    @media (max-width: 1600px) {
        .header-details {
            width: 100%;
        }
    }

    @media (max-width: 767px) {
        .header-title {
            font-size: 24px;
            line-height: 24px;
        }

    }

    @media (max-width: 430px) {

    }
`;